import PropTypes from 'prop-types';
import Head from 'next/head';
import compose from 'lodash/flowRight';
import get from 'lodash/get';
import Typography from '@material-ui/core/Typography';
import MLink from '@material-ui/core/Link';
import { graphql } from '@apollo/client/react/hoc';
import Loading from '../../components/loading';
import Main from '../../components/main';
import ErrorMessage from '../../components/error-message';
import { citiesQuery } from '../../apollo/cities';
import { buildTitle } from '../../utils/layout';
import MaterialLink from '../../components/material-link';
import consumeAppContext from '../../consumers/app';
import config from '../../config';

const CityIndex = (props) => {
  const { error, loading, cities, loggedInUser } = props;

  if (error) {
    return <ErrorMessage message='An error occurred while loading cities.' error={error} />;
  }
  if (loading) { return <Loading />; }

  return (
    <Main>
      <Head>
        <title>{buildTitle('Cities')}</title>
      <link rel="canonical" href={`${config().universal.baseUri}/cities`} />
      </Head>

      <Typography variant="h1">Cities</Typography>

      <ul>
        {cities.map((city) => {
          return (
            <li key={city.id}>
              <MaterialLink href="/cities/[slug]" as={`/cities/${city.slug}`}>
                {city.name}
              </MaterialLink>
              {city.id === get(loggedInUser, 'primaryCity.id') && ' (Primary City)'}
            </li>
          );
        })}
      </ul>

      <p>
        Don&lsquo;t see your city?
        {' '}
        <MLink href="https://mailchi.mp/5ba72b809dd0/everyday-rides-city-waitlist" target="_blank" rel="noopener noreferrer">
          Sign up to get notified
        </MLink>
        {' '}
        when more cities launch.
      </p>
    </Main>
  );
};

CityIndex.propTypes = {
  cities: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.object,
  loggedInUser: PropTypes.object
};

export default compose(
  consumeAppContext,
  graphql(citiesQuery, {
    props: ({ data: { cities, loading, error } }) => {
      return {
        cities,
        loading: loading,
        error: error
      };
    }
  })
)(CityIndex);